import React, { useMemo } from 'react';
import moment from 'moment';
import { AccEventsResponse } from '../../services/accounting';
import { toCurrency } from '../../utils/utils';
import DataGrid, { DataGridColDef } from '../DataGrid/DataGrid';
import { Typography } from 'antd';
import { noop } from 'lodash';

type AccountingEventsTableProps = {
  eventtype: string;
  objecttype: string;
  objectid: number;
  data?: AccEventsResponse[];
  isLoading?: boolean;
  onSelect?: (accountingEvent: AccEventsResponse) => void;
};

const AccountingEventsTable = (props: AccountingEventsTableProps) => {
  const { onSelect = noop, data = [], isLoading = false } = props;

  const columns = useMemo<DataGridColDef<AccEventsResponse>[]>(
    () => [
      {
        comcode: 'AccEvent.eventdate',
        dataIndex: 'eventdate',
        width: 80,
        render: (eventdate) => moment(eventdate).format('YYYY-MM-DD'),
      },
      {
        comcode: 'AccEvent.accmodel',
        dataIndex: 'accmodel',
        width: 80,
      },
      {
        comcode: 'AccEvent.eventtypelabel',
        dataIndex: 'eventtypelabel',
        width: 200,
      },
      {
        comcode: 'AccEvent.ctedirection',
        dataIndex: 'ctedirection',
        width: 50,
      },
      {
        comcode: 'AccEvent.eventstatus',
        dataIndex: 'eventstatus',
        width: 80,
      },
      {
        comcode: 'AccEvent.objectreference',
        dataIndex: 'objectreference',
        width: 150,
      },
      {
        comcode: 'AccEvent.accountingreference',
        dataIndex: 'accountingreference',
        width: 150,
        render: (accountingreference, record) =>
          accountingreference != null ? (
            <Typography.Link
              onClick={(event) => {
                event.preventDefault();
                onSelect(record);
              }}
            >
              {accountingreference}
            </Typography.Link>
          ) : null,
      },
      {
        comcode: 'AccEvent.accountingdate',
        dataIndex: 'accountingdate',
        width: 80,
      },
      {
        comcode: 'AccEvent.postingdate',
        dataIndex: 'postingdate',
        width: 80,
      },
      {
        comcode: 'AccEvent.netamount',
        dataIndex: 'netamount',
        width: 100,
        render: toCurrency,
      },
    ],
    [onSelect]
  );

  return (
    <DataGrid
      columns={columns}
      dataSource={data}
      isLoading={isLoading}
      scroll={{ x: 1000, y: 300 }}
      pagination={{ pageSize: 10 }}
      rowKey={({ cteid }) => cteid}
    />
  );
};

export default AccountingEventsTable;